// Row 4.5 — offline detection primitive. Standard web-platform signal (navigator.onLine +
// window online/offline events); SSR-safe (defaults to online when no window). Exposed as a
// hook so cache-aware consumers can react to connectivity (the row's "cache hooks" surface —
// offline data caching itself is CFR-scoped, not built here).
import { useEffect, useState } from "react";

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
}
